import { VehicleFeature } from '@/catalog/types/vehicle';

export function normalizeDisplayName(feature: VehicleFeature): VehicleFeature {
  const displayValue =
    feature.display_value?.toLowerCase() === 'true'
      ? 'Yes'
      : feature.display_value?.toLowerCase() === 'false'
        ? 'No'
        : feature.display_value;

  return {
    ...feature,
    display_value: displayValue,
  };
}
